import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import IResponseBaseTDto from '../../API/Interfaces/IResponseBaseTDto';
import LocationsServiceAPI from '../../API/Services/LocationServiceAPI';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import EntityDetails, { IEntityDetailsProps, IEntityDetailsBaseProps } from '../../Layout/EntityDetails';
import DetailsBox from '../../Layout/Components/DetailsBox';
import { LocationChainIcon, LocationDevicesIcon } from '../../Layout/Components/Icons';
import { IDeviceDetailsDto } from '../../API/Interfaces/IDeviceDtos';
import DetailsError from '../../Layout/Components/DetailsError';
import DeviceServiceAPI from '../../API/Services/DeviceServiceAPI';
import { Button } from '@material-ui/core';
import ConfirmModal, { IConfirmModal } from '../../Layout/Components/ConfirmModal';
import Helper from '../../Utils/Helpers';

export const Device = (props: IEntityDetailsBaseProps) => {
	const { enqueueSnackbar } = useSnackbar();
	const { t } = useTranslation();

	const { id } = useParams<{ id: string }>();
	const [entity, setEntity] = useState(props.entity);
	const [noData, setNoData] = useState(false);
	const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
	const errorDialog = (message?: string) =>
		enqueueSnackbar(`${t('common.errorOccured')}${message ? ': ' : ''}${message && message}`, { variant: 'error' });

	const fetchEntity = async function (id: string) {
		try {
			const response: IResponseBaseTDto<IDeviceDetailsDto> = await DeviceServiceAPI.GetOne(id);
			if (response) return response;
		} catch (e) {
			errorDialog(e.message);
		}
		return undefined;
	};

	const getDevice = async () => {
		if (id) {
			const e = await fetchEntity(id);
			if (e) {
				setEntity(e);
			} else setNoData(true);
		}
	};

	useEffect(() => {
		getDevice();

		// eslint-disable-next-line
	}, []);

	const sendKeepAliveCommand = async function () {
		Helper.setLoader(true);
		try {
			const response = await DeviceServiceAPI.SynchronizeCampaign(id);
			if (response.success) {
				setIsConfirmModalOpen(false);
				enqueueSnackbar(t('device.successCommand'), { variant: 'success' });
				Helper.setLoader(false);
			} else {
				errorDialog(t(`errorCodes.${response.errors[0].errorCode}`));
				Helper.setLoader(false);
			}
		} catch (e) {
			Helper.setLoader(false);
			errorDialog(e.message);
		}
	};

	const detailsProps: IEntityDetailsProps = {
		detailTitle: entity?.name || '',
		entityType: t('report.Table.DeviceNameHeader'),
		entity: entity,
		api: LocationsServiceAPI,
		isEditable: false,
		isRemovable: false,
		openModal: () => {},
		entityDetailsComponent: <></>,
		entityActionIconsComponent: <></>,
		entitySubsetTableComponent: (
			<>
				{entity ? (
					<DetailsBox
						icon={LocationDevicesIcon}
						schema={[
							{
								title: t('device.device'),
								dataElement: entity.name,
								rowWithIcon: [
									{
										icon: (
											<div style={{ height: '19px' }}>
												<LocationChainIcon />
											</div>
										),
										text:
											entity.corporationName +
											' / ' +
											entity.locationName +
											' ul. ' +
											entity.street +
											' ' +
											entity.city,
									},
									{ icon: <LocationChainIcon />, text: entity.deviceIdentifier },
								],
							},
						]}
					/>
				) : null}
			</>
		),
		headerButtons: (
			<Button color='primary' variant='outlined' onClick={() => setIsConfirmModalOpen(true)} style={{ marginLeft: '20px' }}>
				{t('device.updateCampaign')}
			</Button>
		),
	};

	const handleConfirmationModalProps: IConfirmModal = {
		handleOperation: sendKeepAliveCommand,
		isOpen: isConfirmModalOpen,
		handleClose: () => setIsConfirmModalOpen(false),
		text: 'Wciśnij OK aby wysłać komendę.',
		variant: 'outlined',
		actionButtonText: t('common.ok'),
	};

	return noData ? (
		<DetailsError />
	) : (
		<>
			<EntityDetails {...detailsProps} />
			{isConfirmModalOpen && <ConfirmModal {...handleConfirmationModalProps} />}
		</>
	);
};
